import React from 'react';

import AdminCardOrderField from '../admin-card-fields/AdminCardOrderField/AdminCardOrderField';
import AdminCardField from '../admin-card-fields/AdminCardField/AdminCardField';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import './AdminCommentCard.css';

const AdminCommentCard = ({
  blogPost,
  comment,
  onEditClickHandler,
  onDeleteClickHandler,
}) => {
  const commentFields = [
    { label: 'Name:', value: comment.name, type: 'text' },
    { label: 'Email:', value: comment.email, type: 'email' },
    { label: 'Website:', value: comment.website, type: 'url' },
    { label: 'Comment:', value: comment.content, type: 'textarea' },
  ];

  return (
    <>
      <div className='comment__list'>
        <div className='admin-comment-top-container'>
          <AdminCardOrderField type='date'>
            {comment?.commentedAt}
          </AdminCardOrderField>
          <div
            className='admin-comment-edit-delete-button-container'
            style={{ marginTop: '0px' }}
          >
            <ContentChangeButton
              iconType='edit'
              onClickHandler={() => onEditClickHandler(blogPost, comment)}
            />
            <ContentChangeButton
              iconType='delete'
              onClickHandler={() => onDeleteClickHandler(blogPost, comment)}
            />
          </div>
        </div>
        <div className='admin-comment-content-container'>
          <div className='comment__group'>
            <div className='comment-fields-container'>
              {commentFields.map((field, i) => (
                <AdminCardField key={i} label={field.label} type={field.type}>
                  {field.value}
                </AdminCardField>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminCommentCard;
